

















































import StoreSubscriber from "@/utils/StoreSubscriber";

declare global {
  interface Window {
    google?: any;
  }
}

import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import PoiCollapsibleList from "@/components/ScoutingPlace/CollapsibleList.vue";
import { currentScoutingStore } from "@/store/typed";
import { ScoutingPlace } from "../../models";
import ScoutingPlaceSelectableItem from "@/components/ScoutingPlace/SelectableItem.vue";

@Component({ components: { PoiCollapsibleList, ScoutingPlaceSelectableItem } })
export default class PoiSearch extends Vue {
  private results: ScoutingPlace[] = [];
  selectedPoi: ScoutingPlace[] = [];
  private pagination = null;
  private searching = false;

  async mounted() {
    currentScoutingStore.$clearMarkers();
    await this.search();
    this.subscribe();
  }

  subscribe() {
    StoreSubscriber.subscribe(
      "currentScouting/$updateSelectionScoutingPlace",
      this.onScoutingPlaceUpdateSelection.bind(this)
    );
  }

  onScoutingPlaceUpdateSelection(payload: ScoutingPlace) {
    const place = this.results.find(
      (scoutingPlace) => scoutingPlace.id === payload.id
    );
    if (place) {
      this.checked(place.id);
    }
  }

  checked(key: string) {
    const alreadySelected = this.scoutingPlaces.find(
      (o: ScoutingPlace) => o.source === "google_places" && o.sourceId === key
    );
    return this.selectedPoi.map((o) => o.id).includes(key) || !!alreadySelected;
  }

  get searchScoutingPlaces() {
    return currentScoutingStore.searchScoutingPlaces;
  }

  get scoutingPlaces() {
    return currentScoutingStore.scoutingPlaces;
  }

  onChecked(checked: boolean, place: ScoutingPlace) {
    place.highlighted = checked;
    if (checked) {
      this.selectedPoi.push(place);
    } else {
      const index = this.selectedPoi.findIndex((o) => o.id === place.id);
      if (index !== -1) {
        this.selectedPoi.splice(index, 1);
      }
    }
    currentScoutingStore.updateSearchScoutingPlace(place);
  }

  get term() {
    return this.$route.params.term;
  }

  back() {
    this.clearMapMarkers();
    this.$router.go(-1);
  }

  clearMapMarkers() {
    currentScoutingStore.setSearchScoutingPlaces([]);
    currentScoutingStore.clearMarkers();
  }

  async saveScoutingPlaces() {
    if (this.selectedPoi.length) {
      await currentScoutingStore.saveScoutingPlaces(this.selectedPoi);
    }
    this.back();
  }

  search() {
    let service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );
    this.searching = true;
    service.textSearch(
      {
        query: this.term,
        fields: [
          "name",
          "formatted_address",
          "business_status",
          "place_id",
          "geometry",
        ],
      },
      (results: any[], status: string, pagination: any) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          const items = results.map((o: any) =>
            ScoutingPlace.fromGooglePlace(o)
          );
          currentScoutingStore.addSearchScoutingPlaces(items);
          this.results.push(...items);
        }
        this.pagination = pagination;
        this.searching = false;
        for (let place of this.searchScoutingPlaces) {
          if (place.source === "google_places") {
            if (
              this.scoutingPlaces
                .map((r: ScoutingPlace) => r.sourceId)
                .includes(place.sourceId)
            ) {
              this.onChecked(true, place);
            }
          }
        }
      }
    );
  }
}
